(async function () {
  if (window.location.pathname.startsWith('/products/')) {
    const productHandle = window.location.pathname.replace('/products/', '');
    const recentlyViewed = JSON.parse(localStorage.getItem('recently_viewed') || '[]');
    const newRecentlyViewed = recentlyViewed.filter((item) => item != productHandle);
    newRecentlyViewed.unshift(productHandle);
    const limit = Shopify.recentlyViewed.limit;
    const reducedHistory = JSON.stringify(newRecentlyViewed.slice(0, limit));
    localStorage.setItem('recently_viewed', reducedHistory);
  }
  const viewHistory = JSON.parse(localStorage.getItem('recently_viewed') || '[]');
  const productsHandle = viewHistory.join(',');
  const title = Shopify.recentlyViewed.title;
  const url = `/pages/sections/product_handle=${productsHandle};title=${title}`;
  const response = await fetch(`${url}?section_id=view-history`);
  if (response.status === 200) {
    const element = document.getElementById(Shopify.recentlyViewed.sectionId);
    element.innerHTML = await response.text();
  }
})();
